import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('IDX_7942c53d3385300c90440c8181', ['name', 'fkUserId'], {})
@Index('IDX_85abe9655804a6cdad7b3af19d', ['fkUserId'], {})
@Entity('_vault_secrets')
export class VaultSecretsEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('text', { name: 'data' })
	public data!: string;

	@Column('varchar', { name: 'key_name', length: 255 })
	public keyName!: string;

	@Column('int', { name: 'fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;

	@Column('json', { name: 'metadata', nullable: true })
	public metadata!: object | null;

	@Column('timestamp', { name: 'accessed_at', nullable: true })
	public accessedAt!: Date | null;

	@ManyToOne(() => UserEntity, (user) => user.vaultSecrets, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
